export const fetchOrThrow = async (url: string, init: RequestInit) => {
  const response = await fetch(url, init)
  const body = await response.json()
  if (!response.ok) {
    throw new Error(`request to ${url} failed with status ${response.status} - body: ${JSON.stringify(body)}`)
  }
  return body
}